import { useEffect } from 'react';
import LandingMainSection from '../../components/PageComponents/LandingPageComponents/LandingBanner/LandingMainSection'
import Navbar from '../../components/CommonComponents/Navbar/Navbar'
import ReimagineBusinessSection from '../../components/PageComponents/LandingPageComponents/BannerImageTextSection/ReimagineBusinessSection';
import IdeasAreCommodities from '../../components/PageComponents/LandingPageComponents/PopularGigs/IdeasAreCommodities';
import TopCategoriesSection from '../../components/PageComponents/LandingPageComponents/LandingWhyChooseGG/TopCategoriesSection';
import FindPerfectFreelancerSection from '../../components/PageComponents/LandingPageComponents/LandingBusinessImg/FindPerfectFreelancerSection';
import Footer from '../../components/CommonComponents/Footer/Footer';
import logAnalyticsEvent from '../../services/AnalyticsManager/AnalyticsManager';
import { GGAnalyticsEvents } from '../../services/AnalyticsManager/GGAnalyticsEvents';
import './LandingPage.scss';

const LandingPage = () => {

  useEffect(() => {
    window.scrollTo(0,0);
    document.title = "GenieGig - India's Premier AI-Powered Freelance Marketplace connecting businesses with skilled freelancers";
    logAnalyticsEvent(GGAnalyticsEvents.LANDING_PAGE_LOADED);
  })

  return (
    <div>
      <Navbar />
      <LandingMainSection/>
      <ReimagineBusinessSection/>
      <IdeasAreCommodities/>
      <TopCategoriesSection/>
      <FindPerfectFreelancerSection/>
      <Footer className='landing-footer'/>
    </div>
  )
}

export default LandingPage